// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file common/v1/common.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { UInt32Value } from "../../google/protobuf/wrappers_pb";
import { LocalizedText } from "../../google/type/localized_text_pb";
import { BadRequest } from "../../google/rpc/error_details_pb";
import { PostalAddress } from "../../google/type/postal_address_pb";
import { PaymentCardScaRequest } from "./three_domain_secure_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";

/**
 * CardNetwork enum lists supported card networks (aka card associations) by the Checkout APIs.
 *
 * @generated from enum common.v1.CardNetwork
 */
export const CardNetwork = proto3.makeEnum(
  "common.v1.CardNetwork",
  [
    {no: 0, name: "CARD_NETWORK_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CARD_NETWORK_VISA", localName: "VISA"},
    {no: 2, name: "CARD_NETWORK_MASTERCARD", localName: "MASTERCARD"},
    {no: 3, name: "CARD_NETWORK_AMEX", localName: "AMEX"},
    {no: 4, name: "CARD_NETWORK_DISCOVER", localName: "DISCOVER"},
    {no: 5, name: "CARD_NETWORK_JCB", localName: "JCB"},
    {no: 6, name: "CARD_NETWORK_MAESTRO", localName: "MAESTRO"},
    {no: 7, name: "CARD_NETWORK_DINERS", localName: "DINERS"},
    {no: 8, name: "CARD_NETWORK_CHASE_VISA_CREDIT", localName: "CHASE_VISA_CREDIT"},
    {no: 9, name: "CARD_NETWORK_CHINA_UNION_PAY", localName: "CHINA_UNION_PAY"},
    {no: 11, name: "CARD_NETWORK_CARTES_BANCAIRES", localName: "CARTES_BANCAIRES"},
    {no: 12, name: "CARD_NETWORK_STORED_VALUE", localName: "STORED_VALUE"},
  ],
);

/**
 * CardType defines a type of payment card.
 *
 * @generated from enum common.v1.CardType
 */
export const CardType = proto3.makeEnum(
  "common.v1.CardType",
  [
    {no: 0, name: "CARD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CARD_TYPE_CREDIT", localName: "CREDIT"},
    {no: 2, name: "CARD_TYPE_DEBIT", localName: "DEBIT"},
    {no: 3, name: "CARD_TYPE_PREPAID", localName: "PREPAID"},
    {no: 4, name: "CARD_TYPE_GIFT", localName: "GIFT"},
  ],
);

/**
 * The individual who decided how the payment will be routed (Cartes Bancaires use-case).
 *
 * @generated from enum common.v1.PreferredRoutingInitiator
 */
export const PreferredRoutingInitiator = proto3.makeEnum(
  "common.v1.PreferredRoutingInitiator",
  [
    {no: 0, name: "PREFERRED_ROUTING_INITIATOR_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PREFERRED_ROUTING_INITIATOR_MERCHANT", localName: "MERCHANT"},
    {no: 2, name: "PREFERRED_ROUTING_INITIATOR_CONSUMER", localName: "CONSUMER"},
  ],
);

/**
 * Card Interactions that define method of payment.
 *
 * @generated from enum common.v1.CardInteractionType
 */
export const CardInteractionType = proto3.makeEnum(
  "common.v1.CardInteractionType",
  [
    {no: 0, name: "CARD_INTERACTION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CARD_INTERACTION_TYPE_CARD_SWIPED", localName: "CARD_SWIPED"},
    {no: 2, name: "CARD_INTERACTION_TYPE_CARD_TAPPED", localName: "CARD_TAPPED"},
    {no: 3, name: "CARD_INTERACTION_TYPE_CHIP_SWIPE", localName: "CHIP_SWIPE"},
    {no: 4, name: "CARD_INTERACTION_TYPE_CARD_INSERTED", localName: "CARD_INSERTED"},
    {no: 5, name: "CARD_INTERACTION_TYPE_CARD_READER", localName: "CARD_READER"},
    {no: 6, name: "CARD_INTERACTION_TYPE_MANUAL_ENTRY", localName: "MANUAL_ENTRY"},
  ],
);

/**
 * DebitAcceptanceType defines the Debit process to take during transactions
 *
 * @generated from enum common.v1.DebitAcceptanceType
 */
export const DebitAcceptanceType = proto3.makeEnum(
  "common.v1.DebitAcceptanceType",
  [
    {no: 0, name: "DEBIT_ACCEPTANCE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DEBIT_ACCEPTANCE_TYPE_DEBIT_FIRST", localName: "DEBIT_FIRST"},
    {no: 2, name: "DEBIT_ACCEPTANCE_TYPE_DEBIT_ONLY", localName: "DEBIT_ONLY"},
  ],
);

/**
 * Bank account types supported by Electronic Check processing.
 *
 * @generated from enum common.v1.EcpBankAccountType
 */
export const EcpBankAccountType = proto3.makeEnum(
  "common.v1.EcpBankAccountType",
  [
    {no: 0, name: "ECP_BANK_ACCOUNT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ECP_BANK_ACCOUNT_TYPE_CUSTOMER_CHECKING", localName: "CUSTOMER_CHECKING"},
    {no: 2, name: "ECP_BANK_ACCOUNT_TYPE_CUSTOMER_SAVINGS", localName: "CUSTOMER_SAVINGS"},
    {no: 3, name: "ECP_BANK_ACCOUNT_TYPE_COMMERCIAL_CHECKING", localName: "COMMERCIAL_CHECKING"},
  ],
);

/**
 * AchVerificationType
 *
 * @generated from enum common.v1.AchVerificationType
 */
export const AchVerificationType = proto3.makeEnum(
  "common.v1.AchVerificationType",
  [
    {no: 0, name: "ACH_VERIFICATION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACH_VERIFICATION_TYPE_BASIC", localName: "BASIC"},
    {no: 2, name: "ACH_VERIFICATION_TYPE_ACCOUNT_STATUS", localName: "ACCOUNT_STATUS"},
    {no: 3, name: "ACH_VERIFICATION_TYPE_ACCOUNT_OWNER", localName: "ACCOUNT_OWNER"},
    {no: 4, name: "ACH_VERIFICATION_TYPE_PRE_NOTE_CREDIT", localName: "PRE_NOTE_CREDIT"},
    {no: 5, name: "ACH_VERIFICATION_TYPE_PRE_NOTE_DEBIT", localName: "PRE_NOTE_DEBIT"},
  ],
);

/**
 * Defines the type of methods of payment using Google Pay, currently the only type is CARD.
 *
 * @generated from enum common.v1.GooglePayPaymentMethodType
 */
export const GooglePayPaymentMethodType = proto3.makeEnum(
  "common.v1.GooglePayPaymentMethodType",
  [
    {no: 0, name: "GOOGLE_PAY_PAYMENT_METHOD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "GOOGLE_PAY_PAYMENT_METHOD_TYPE_CARD", localName: "CARD"},
  ],
);

/**
 * Defines the type of tokenization applied to the selected payment method.
 *
 * @generated from enum common.v1.GooglePayTokenizationType
 */
export const GooglePayTokenizationType = proto3.makeEnum(
  "common.v1.GooglePayTokenizationType",
  [
    {no: 0, name: "GOOGLE_PAY_TOKENIZATION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "GOOGLE_PAY_TOKENIZATION_TYPE_PAYMENT_GATEWAY", localName: "PAYMENT_GATEWAY"},
    {no: 2, name: "GOOGLE_PAY_TOKENIZATION_TYPE_DIRECT", localName: "DIRECT"},
  ],
);

/**
 * Defines the version of the protocol used to decrypt by Google Pay.
 *
 * @generated from enum common.v1.GooglePayProtocolVersion
 */
export const GooglePayProtocolVersion = proto3.makeEnum(
  "common.v1.GooglePayProtocolVersion",
  [
    {no: 0, name: "GOOGLE_PAY_PROTOCOL_VERSION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "GOOGLE_PAY_PROTOCOL_VERSION_ECV1", localName: "ECV1"},
    {no: 2, name: "GOOGLE_PAY_PROTOCOL_VERSION_ECV2", localName: "ECV2"},
  ],
);

/**
 * Defines supported payment gateway types.
 *
 * @generated from enum common.v1.PaymentGatewayType
 */
export const PaymentGatewayType = proto3.makeEnum(
  "common.v1.PaymentGatewayType",
  [
    {no: 0, name: "PAYMENT_GATEWAY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAYMENT_GATEWAY_TYPE_ORBITAL", localName: "ORBITAL"},
    {no: 2, name: "PAYMENT_GATEWAY_TYPE_UPG", localName: "UPG"},
    {no: 3, name: "PAYMENT_GATEWAY_TYPE_WALLET", localName: "WALLET"},
    {no: 100, name: "PAYMENT_GATEWAY_TYPE_MOCK", localName: "MOCK"},
  ],
);

/**
 * Cookie policy enums
 *
 * @generated from enum common.v1.CookiePolicy
 */
export const CookiePolicy = proto3.makeEnum(
  "common.v1.CookiePolicy",
  [
    {no: 0, name: "COOKIE_POLICY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COOKIE_POLICY_ACCEPT_ALL", localName: "ACCEPT_ALL"},
    {no: 2, name: "COOKIE_POLICY_ONLY_NECESSARY", localName: "ONLY_NECESSARY"},
  ],
);

/**
 * @generated from enum common.v1.PaymentMethodType
 */
export const PaymentMethodType = proto3.makeEnum(
  "common.v1.PaymentMethodType",
  [
    {no: 0, name: "PAYMENT_METHOD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAYMENT_METHOD_TYPE_CARD", localName: "CARD"},
    {no: 2, name: "PAYMENT_METHOD_TYPE_ELECTRONIC_CHECK", localName: "ELECTRONIC_CHECK"},
    {no: 3, name: "PAYMENT_METHOD_TYPE_APPLE_PAY", localName: "APPLE_PAY"},
    {no: 4, name: "PAYMENT_METHOD_TYPE_SEPA", localName: "SEPA"},
    {no: 5, name: "PAYMENT_METHOD_TYPE_GOOGLE_PAY", localName: "GOOGLE_PAY"},
    {no: 6, name: "PAYMENT_METHOD_TYPE_PAZE", localName: "PAZE"},
    {no: 7, name: "PAYMENT_METHOD_TYPE_PAY_BY_BANK", localName: "PAY_BY_BANK"},
    {no: 8, name: "PAYMENT_METHOD_TYPE_ALIPAY", localName: "ALIPAY"},
    {no: 9, name: "PAYMENT_METHOD_TYPE_PAYPAL", localName: "PAYPAL"},
    {no: 10, name: "PAYMENT_METHOD_TYPE_WECHAT_PAY", localName: "WECHAT_PAY"},
    {no: 11, name: "PAYMENT_METHOD_TYPE_IDEAL", localName: "IDEAL"},
    {no: 12, name: "PAYMENT_METHOD_TYPE_SOFORT", localName: "SOFORT"},
    {no: 13, name: "PAYMENT_METHOD_TYPE_GIROPAY", localName: "GIROPAY"},
    {no: 14, name: "PAYMENT_METHOD_TYPE_TRUSTLY", localName: "TRUSTLY"},
    {no: 15, name: "PAYMENT_METHOD_TYPE_GIFT_CARD", localName: "GIFT_CARD"},
    {no: 16, name: "PAYMENT_METHOD_TYPE_KLARNA", localName: "KLARNA"},
  ],
);

/**
 * Defines payment authorization methods/modes.
 *
 * @generated from enum common.v1.AuthMethod
 */
export const AuthMethod = proto3.makeEnum(
  "common.v1.AuthMethod",
  [
    {no: 0, name: "AUTH_METHOD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "AUTH_METHOD_VERIFY_ONLY", localName: "VERIFY_ONLY"},
    {no: 2, name: "AUTH_METHOD_CART_AMOUNT", localName: "CART_AMOUNT"},
    {no: 3, name: "AUTH_METHOD_CART_AMOUNT_AFTER_VERIFY", localName: "CART_AMOUNT_AFTER_VERIFY"},
    {no: 4, name: "AUTH_METHOD_TOKENIZE_ONLY", localName: "TOKENIZE_ONLY"},
  ],
);

/**
 * Defines supported customer transaction message types.
 * TODO(vmiksonov): Remove this enum once we start to use CofOptions.
 *
 * @generated from enum common.v1.CitMessageType
 * @deprecated
 */
export const CitMessageType = proto3.makeEnum(
  "common.v1.CitMessageType",
  [
    {no: 0, name: "CIT_MESSAGE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CIT_MESSAGE_TYPE_STORED_CREDENTIALS", localName: "STORED_CREDENTIALS"},
    {no: 2, name: "CIT_MESSAGE_TYPE_UNSCHEDULED_CREDENTIALS_ON_FILE", localName: "UNSCHEDULED_CREDENTIALS_ON_FILE"},
    {no: 3, name: "CIT_MESSAGE_TYPE_RECURRING_TRANSACTION", localName: "RECURRING_TRANSACTION"},
    {no: 4, name: "CIT_MESSAGE_TYPE_ESTIMATED_AUTH_AMOUNT", localName: "ESTIMATED_AUTH_AMOUNT"},
    {no: 5, name: "CIT_MESSAGE_TYPE_INSTALLMENTS", localName: "INSTALLMENTS"},
    {no: 6, name: "CIT_MESSAGE_TYPE_GENERAL_TRANSACTION", localName: "GENERAL_TRANSACTION"},
  ],
);

/**
 * Defines payment capture methods/modes.
 *
 * @generated from enum common.v1.CaptureMethod
 */
export const CaptureMethod = proto3.makeEnum(
  "common.v1.CaptureMethod",
  [
    {no: 0, name: "CAPTURE_METHOD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CAPTURE_METHOD_MANUAL", localName: "MANUAL"},
    {no: 2, name: "CAPTURE_METHOD_NOW", localName: "NOW"},
    {no: 3, name: "CAPTURE_METHOD_DELAYED", localName: "DELAYED"},
  ],
);

/**
 * Defines status of pay request.
 *
 * @generated from enum common.v1.PayRequestStatus
 */
export const PayRequestStatus = proto3.makeEnum(
  "common.v1.PayRequestStatus",
  [
    {no: 0, name: "PAY_REQUEST_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAY_REQUEST_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "PAY_REQUEST_STATUS_TRANSIENT_FAILURE", localName: "TRANSIENT_FAILURE"},
    {no: 3, name: "PAY_REQUEST_STATUS_FAILURE", localName: "FAILURE"},
    {no: 7, name: "PAY_REQUEST_STATUS_PENDING", localName: "PENDING"},
  ],
);

/**
 * Defines possible types of token.
 *
 * @generated from enum common.v1.TokenType
 */
export const TokenType = proto3.makeEnum(
  "common.v1.TokenType",
  [
    {no: 0, name: "TOKEN_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TOKEN_TYPE_ACQUIRER", localName: "ACQUIRER"},
    {no: 2, name: "TOKEN_TYPE_NETWORK", localName: "NETWORK"},
    {no: 3, name: "TOKEN_TYPE_EMPTY", localName: "EMPTY"},
  ],
);

/**
 * Defines the status of a card token during a payment transaction.
 *
 * @generated from enum common.v1.TokenizationStatus
 */
export const TokenizationStatus = proto3.makeEnum(
  "common.v1.TokenizationStatus",
  [
    {no: 0, name: "TOKENIZATION_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TOKENIZATION_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "TOKENIZATION_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * Various configurations for collecting Billing Address.
 *
 * @generated from enum common.v1.BillingAddressCollectionFields
 */
export const BillingAddressCollectionFields = proto3.makeEnum(
  "common.v1.BillingAddressCollectionFields",
  [
    {no: 0, name: "BILLING_ADDRESS_COLLECTION_FIELDS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "BILLING_ADDRESS_COLLECTION_FIELDS_NAME_AND_FULL_ADDRESS", localName: "NAME_AND_FULL_ADDRESS"},
    {no: 2, name: "BILLING_ADDRESS_COLLECTION_FIELDS_FULL_ADDRESS", localName: "FULL_ADDRESS"},
    {no: 3, name: "BILLING_ADDRESS_COLLECTION_FIELDS_FULL_ADDRESS_NO_STREET_ADDRESS_2", localName: "FULL_ADDRESS_NO_STREET_ADDRESS_2"},
    {no: 4, name: "BILLING_ADDRESS_COLLECTION_FIELDS_BILLING_ZIP_ONLY", localName: "BILLING_ZIP_ONLY"},
    {no: 5, name: "BILLING_ADDRESS_COLLECTION_FIELDS_NONE", localName: "NONE"},
  ],
);

/**
 * Specifies the order origination.
 *
 * @generated from enum common.v1.OrderOrigination
 */
export const OrderOrigination = proto3.makeEnum(
  "common.v1.OrderOrigination",
  [
    {no: 0, name: "ORDER_ORIGINATION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_ORIGINATION_MERCHANT", localName: "MERCHANT"},
    {no: 2, name: "ORDER_ORIGINATION_PAYMENT_LINK", localName: "PAYMENT_LINK"},
    {no: 3, name: "ORDER_ORIGINATION_ORDER", localName: "ORDER"},
  ],
);

/**
 * Defines Merchant Onboarding status
 *
 * @generated from enum common.v1.OnboardingStatus
 */
export const OnboardingStatus = proto3.makeEnum(
  "common.v1.OnboardingStatus",
  [
    {no: 0, name: "ONBOARDING_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ONBOARDING_STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 2, name: "ONBOARDING_STATUS_PENDING", localName: "PENDING"},
    {no: 3, name: "ONBOARDING_STATUS_INACTIVE", localName: "INACTIVE"},
  ],
);

/**
 * @generated from enum common.v1.UnitTime
 */
export const UnitTime = proto3.makeEnum(
  "common.v1.UnitTime",
  [
    {no: 0, name: "UNIT_TIME_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UNIT_TIME_MINUTES", localName: "MINUTES"},
    {no: 2, name: "UNIT_TIME_HOURS", localName: "HOURS"},
    {no: 3, name: "UNIT_TIME_DAYS", localName: "DAYS"},
  ],
);

/**
 * Defines the access privileges for merchant portal users
 *
 * @generated from enum common.v1.AccessPrivilege
 */
export const AccessPrivilege = proto3.makeEnum(
  "common.v1.AccessPrivilege",
  [
    {no: 0, name: "ACCESS_PRIVILEGE_TYPE_UNSPECIFIED", localName: "TYPE_UNSPECIFIED"},
    {no: 1, name: "ACCESS_PRIVILEGE_TYPE_READ", localName: "TYPE_READ"},
    {no: 2, name: "ACCESS_PRIVILEGE_TYPE_READ_WRITE", localName: "TYPE_READ_WRITE"},
    {no: 3, name: "ACCESS_PRIVILEGE_TYPE_NONE", localName: "TYPE_NONE"},
  ],
);

/**
 * @generated from enum common.v1.Operation
 */
export const Operation = proto3.makeEnum(
  "common.v1.Operation",
  [
    {no: 0, name: "OPERATION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "OPERATION_ADD", localName: "ADD"},
    {no: 2, name: "OPERATION_REMOVE", localName: "REMOVE"},
    {no: 3, name: "OPERATION_REMOVE_ALL", localName: "REMOVE_ALL"},
    {no: 4, name: "OPERATION_MERGE_ALL_IN", localName: "MERGE_ALL_IN"},
  ],
);

/**
 * Defines the order for the response of list endpoints
 *
 * @generated from enum common.v1.OrderBy
 */
export const OrderBy = proto3.makeEnum(
  "common.v1.OrderBy",
  [
    {no: 0, name: "ORDER_BY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_BY_ASC", localName: "ASC"},
    {no: 2, name: "ORDER_BY_DESC", localName: "DESC"},
  ],
);

/**
 * Global Mandates Type.
 *
 * @generated from enum common.v1.GlobalMandateType
 */
export const GlobalMandateType = proto3.makeEnum(
  "common.v1.GlobalMandateType",
  [
    {no: 0, name: "GLOBAL_MANDATE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "GLOBAL_MANDATE_TYPE_SAVE_FOR_FUTURE_PAYMENT", localName: "SAVE_FOR_FUTURE_PAYMENT"},
  ],
);

/**
 * Global Mandates Status.
 *
 * @generated from enum common.v1.GlobalMandateStatus
 */
export const GlobalMandateStatus = proto3.makeEnum(
  "common.v1.GlobalMandateStatus",
  [
    {no: 0, name: "GLOBAL_MANDATE_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "GLOBAL_MANDATE_STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 2, name: "GLOBAL_MANDATE_STATUS_INACTIVE", localName: "INACTIVE"},
  ],
);

/**
 * Defines status of refund request.
 *
 * @generated from enum common.v1.RefundRequestStatus
 */
export const RefundRequestStatus = proto3.makeEnum(
  "common.v1.RefundRequestStatus",
  [
    {no: 0, name: "REFUND_REQUEST_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REFUND_REQUEST_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "REFUND_REQUEST_STATUS_TRANSIENT_FAILURE", localName: "TRANSIENT_FAILURE"},
    {no: 3, name: "REFUND_REQUEST_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * Defines status of cancel request.
 *
 * @generated from enum common.v1.CancelRequestStatus
 */
export const CancelRequestStatus = proto3.makeEnum(
  "common.v1.CancelRequestStatus",
  [
    {no: 0, name: "CANCEL_REQUEST_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CANCEL_REQUEST_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "CANCEL_REQUEST_STATUS_TRANSIENT_FAILURE", localName: "TRANSIENT_FAILURE"},
    {no: 3, name: "CANCEL_REQUEST_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * Defines status of tip request.
 *
 * @generated from enum common.v1.TipRequestStatus
 */
export const TipRequestStatus = proto3.makeEnum(
  "common.v1.TipRequestStatus",
  [
    {no: 0, name: "TIP_REQUEST_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TIP_REQUEST_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "TIP_REQUEST_STATUS_TRANSIENT_FAILURE", localName: "TRANSIENT_FAILURE"},
    {no: 3, name: "TIP_REQUEST_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * Defines status of nonce generation request.
 *
 * @generated from enum common.v1.NonceGenerationRequestStatus
 */
export const NonceGenerationRequestStatus = proto3.makeEnum(
  "common.v1.NonceGenerationRequestStatus",
  [
    {no: 0, name: "NONCE_GENERATION_REQUEST_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "NONCE_GENERATION_REQUEST_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "NONCE_GENERATION_REQUEST_STATUS_TRANSIENT_FAILURE", localName: "TRANSIENT_FAILURE"},
    {no: 3, name: "NONCE_GENERATION_REQUEST_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * Defines status of capture request.
 *
 * @generated from enum common.v1.CaptureRequestStatus
 */
export const CaptureRequestStatus = proto3.makeEnum(
  "common.v1.CaptureRequestStatus",
  [
    {no: 0, name: "CAPTURE_REQUEST_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CAPTURE_REQUEST_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "CAPTURE_REQUEST_STATUS_TRANSIENT_FAILURE", localName: "TRANSIENT_FAILURE"},
    {no: 3, name: "CAPTURE_REQUEST_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * @generated from enum common.v1.OrderStatus
 */
export const OrderStatus = proto3.makeEnum(
  "common.v1.OrderStatus",
  [
    {no: 0, name: "ORDER_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_STATUS_CREATED", localName: "CREATED"},
    {no: 2, name: "ORDER_STATUS_PAYMENT_PENDING", localName: "PAYMENT_PENDING"},
    {no: 3, name: "ORDER_STATUS_PAYMENT_FAILED", localName: "PAYMENT_FAILED"},
    {no: 4, name: "ORDER_STATUS_COMPLETED", localName: "COMPLETED"},
    {no: 5, name: "ORDER_STATUS_REFUNDED", localName: "REFUNDED"},
    {no: 6, name: "ORDER_STATUS_PARTIAL_REFUNDED", localName: "PARTIAL_REFUNDED"},
    {no: 7, name: "ORDER_STATUS_CANCELLED", localName: "CANCELLED"},
  ],
);

/**
 * @generated from enum common.v1.RefundPaymentMethod
 */
export const RefundPaymentMethod = proto3.makeEnum(
  "common.v1.RefundPaymentMethod",
  [
    {no: 0, name: "REFUND_PAYMENT_METHOD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REFUND_PAYMENT_METHOD_ORIGINAL_MOP", localName: "ORIGINAL_MOP"},
    {no: 2, name: "REFUND_PAYMENT_METHOD_TRANSACTION_REFERENCE", localName: "TRANSACTION_REFERENCE"},
    {no: 3, name: "REFUND_PAYMENT_METHOD_CARD_PRESENT", localName: "CARD_PRESENT"},
    {no: 4, name: "REFUND_PAYMENT_METHOD_NOT_APPLICABLE", localName: "NOT_APPLICABLE"},
  ],
);

/**
 * @generated from enum common.v1.PrepaymentPaymentMethod
 */
export const PrepaymentPaymentMethod = proto3.makeEnum(
  "common.v1.PrepaymentPaymentMethod",
  [
    {no: 0, name: "PREPAYMENT_PAYMENT_METHOD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PREPAYMENT_PAYMENT_METHOD_CASH", localName: "CASH"},
    {no: 2, name: "PREPAYMENT_PAYMENT_METHOD_OTHER", localName: "OTHER"},
    {no: 3, name: "PREPAYMENT_PAYMENT_METHOD_CARD", localName: "CARD"},
  ],
);

/**
 * @generated from enum common.v1.RefundStatus
 */
export const RefundStatus = proto3.makeEnum(
  "common.v1.RefundStatus",
  [
    {no: 0, name: "REFUND_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REFUND_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "REFUND_STATUS_PENDING", localName: "PENDING"},
    {no: 3, name: "REFUND_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * @generated from enum common.v1.TransactionStatus
 */
export const TransactionStatus = proto3.makeEnum(
  "common.v1.TransactionStatus",
  [
    {no: 0, name: "TRANSACTION_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TRANSACTION_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "TRANSACTION_STATUS_PENDING", localName: "PENDING"},
    {no: 3, name: "TRANSACTION_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * @generated from enum common.v1.LpmType
 */
export const LpmType = proto3.makeEnum(
  "common.v1.LpmType",
  [
    {no: 0, name: "LPM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LPM_TYPE_PAY_PAL", localName: "PAY_PAL"},
    {no: 2, name: "LPM_TYPE_ALI_PAY", localName: "ALI_PAY"},
    {no: 3, name: "LPM_TYPE_WECHAT_PAY", localName: "WECHAT_PAY"},
    {no: 4, name: "LPM_TYPE_IDEAL", localName: "IDEAL"},
    {no: 5, name: "LPM_TYPE_SOFORT", localName: "SOFORT"},
    {no: 6, name: "LPM_TYPE_GIRO_PAY", localName: "GIRO_PAY"},
    {no: 7, name: "LPM_TYPE_TRUSTLY", localName: "TRUSTLY"},
  ],
);

/**
 * @generated from enum common.v1.PaymentUpdateStatus
 */
export const PaymentUpdateStatus = proto3.makeEnum(
  "common.v1.PaymentUpdateStatus",
  [
    {no: 0, name: "PAYMENT_UPDATE_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAYMENT_UPDATE_STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "PAYMENT_UPDATE_STATUS_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * @generated from enum common.v1.PayResultType
 */
export const PayResultType = proto3.makeEnum(
  "common.v1.PayResultType",
  [
    {no: 0, name: "PAY_RESULT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAY_RESULT_TYPE_SCA", localName: "SCA"},
    {no: 2, name: "PAY_RESULT_TYPE_LPM", localName: "LPM"},
    {no: 3, name: "PAY_RESULT_TYPE_PBB", localName: "PBB"},
    {no: 4, name: "PAY_RESULT_TYPE_VERIFICATION", localName: "VERIFICATION"},
    {no: 5, name: "PAY_RESULT_TYPE_KLARNA", localName: "KLARNA"},
  ],
);

/**
 * @generated from enum common.v1.UserType
 */
export const UserType = proto3.makeEnum(
  "common.v1.UserType",
  [
    {no: 0, name: "USER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "USER_TYPE_INTERNAL", localName: "INTERNAL"},
    {no: 2, name: "USER_TYPE_EXTERNAL", localName: "EXTERNAL"},
  ],
);

/**
 * @generated from enum common.v1.MerchantEventSource
 */
export const MerchantEventSource = proto3.makeEnum(
  "common.v1.MerchantEventSource",
  [
    {no: 0, name: "MERCHANT_EVENT_SOURCE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MERCHANT_EVENT_SOURCE_PEU", localName: "PEU"},
    {no: 2, name: "MERCHANT_EVENT_SOURCE_PEOPLESOFT", localName: "PEOPLESOFT"},
    {no: 3, name: "MERCHANT_EVENT_SOURCE_MU", localName: "MU"},
  ],
);

/**
 * @generated from enum common.v1.DlqStatus
 */
export const DlqStatus = proto3.makeEnum(
  "common.v1.DlqStatus",
  [
    {no: 0, name: "DLQ_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DLQ_STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 2, name: "DLQ_STATUS_COMPLETED", localName: "COMPLETED"},
  ],
);

/**
 * @generated from enum common.v1.ReplayMerchantOnboardingEventResult
 */
export const ReplayMerchantOnboardingEventResult = proto3.makeEnum(
  "common.v1.ReplayMerchantOnboardingEventResult",
  [
    {no: 0, name: "REPLAY_MERCHANT_ONBOARDING_EVENT_RESULT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REPLAY_MERCHANT_ONBOARDING_EVENT_RESULT_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "REPLAY_MERCHANT_ONBOARDING_EVENT_RESULT_FAILURE", localName: "FAILURE"},
  ],
);

/**
 * @generated from enum common.v1.MerchantSettingsSource
 */
export const MerchantSettingsSource = proto3.makeEnum(
  "common.v1.MerchantSettingsSource",
  [
    {no: 0, name: "MERCHANT_SETTINGS_SOURCE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MERCHANT_SETTINGS_SOURCE_TECHOPS_API", localName: "TECHOPS_API"},
    {no: 2, name: "MERCHANT_SETTINGS_SOURCE_UI", localName: "UI"},
    {no: 3, name: "MERCHANT_SETTINGS_SOURCE_PEU_EVENT", localName: "PEU_EVENT"},
    {no: 4, name: "MERCHANT_SETTINGS_SOURCE_PEOPLESOFT_EVENT", localName: "PEOPLESOFT_EVENT"},
  ],
);

/**
 * Specifies the action that the consumer initiates with the payment method using
 * profile management.
 *
 * @generated from enum common.v1.ConsumerActionCode
 */
export const ConsumerActionCode = proto3.makeEnum(
  "common.v1.ConsumerActionCode",
  [
    {no: 0, name: "CONSUMER_ACTION_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONSUMER_ACTION_CODE_ADD", localName: "ADD"},
    {no: 2, name: "CONSUMER_ACTION_CODE_EDIT", localName: "EDIT"},
    {no: 3, name: "CONSUMER_ACTION_CODE_DELETE", localName: "DELETE"},
    {no: 4, name: "CONSUMER_ACTION_CODE_ADD_MARK_DEFAULT", localName: "ADD_MARK_DEFAULT"},
    {no: 5, name: "CONSUMER_ACTION_CODE_EDIT_MARK_DEFAULT", localName: "EDIT_MARK_DEFAULT"},
    {no: 6, name: "CONSUMER_ACTION_CODE_MARK_DEFAULT", localName: "MARK_DEFAULT"},
  ],
);

/**
 * Represents a monetary amount.
 * Examples:
 * USD 10.99:
 *   amount       : 109900
 *   currency_code: USD
 *   decimal_count: 4
 *
 * USD 10.99:
 *   amount       : 1099
 *   currency_code: USD
 *   decimal_count: 2
 *
 * USD 10.99:
 *   amount       : 1099
 *   currency_code: USD
 * Note: in this example default decimal_count for USD currency was used
 *
 * USD 10.9912:
 *   amount       : 109912
 *   currency_code: USD
 *   decimal_count: 4
 *
 * @generated from message common.v1.Money
 */
export const Money = proto3.makeMessageType(
  "common.v1.Money",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "decimal_count", kind: "message", T: UInt32Value },
  ],
);

/**
 * Specifies an address.
 * Note: This message models mostly US addresses, other countries will require extra fields.
 *
 * @generated from message common.v1.Address
 */
export const Address = proto3.makeMessageType(
  "common.v1.Address",
  () => [
    { no: 1, name: "recipient_name", jsonName: "recipientFullName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "line1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "line2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "line3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Specifies an address.
 * Note: This message models mostly US addresses, other countries will require extra fields.
 *
 * @generated from message common.v1.BusinessAddress
 */
export const BusinessAddress = proto3.makeMessageType(
  "common.v1.BusinessAddress",
  () => [
    { no: 1, name: "line1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "line2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "line3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "address_type_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Provides localized strings that is friendly to return to the end user.
 *
 * @generated from message common.v1.LocalizedString
 */
export const LocalizedString = proto3.makeMessageType(
  "common.v1.LocalizedString",
  () => [
    { no: 1, name: "translation", kind: "message", T: LocalizedText, repeated: true },
  ],
);

/**
 * Represents a decimal value, similar to Java's BigDecimal.
 * Example: 12345.6789 -> { units = 12345, nanos = 678900000 }
 * Example: -12345.6789 -> { units = -12345, nanos = -678900000 }
 *
 * @generated from message common.v1.Decimal
 */
export const Decimal = proto3.makeMessageType(
  "common.v1.Decimal",
  () => [
    { no: 1, name: "units", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "nanos", kind: "scalar", T: 15 /* ScalarType.SFIXED32 */ },
  ],
);

/**
 * @generated from message common.v1.UseBadRequest
 */
export const UseBadRequest = proto3.makeMessageType(
  "common.v1.UseBadRequest",
  () => [
    { no: 1, name: "bad_request", kind: "message", T: BadRequest },
  ],
);

/**
 * @generated from message common.v1.UseMoney
 */
export const UseMoney = proto3.makeMessageType(
  "common.v1.UseMoney",
  () => [
    { no: 1, name: "money", kind: "message", T: Money },
  ],
);

/**
 * TODO: add comment that is used for Getting Settings
 *
 * @generated from message common.v1.PaymentMethodSettings
 */
export const PaymentMethodSettings = proto3.makeMessageType(
  "common.v1.PaymentMethodSettings",
  () => [
    { no: 1, name: "card_payment_setting", kind: "message", T: PaymentMethodSettings_CardPaymentSetting },
  ],
);

/**
 * @generated from message common.v1.PaymentMethodSettings.CardPaymentSetting
 */
export const PaymentMethodSettings_CardPaymentSetting = proto3.makeMessageType(
  "common.v1.PaymentMethodSettings.CardPaymentSetting",
  () => [
    { no: 1, name: "accepted_card_network", kind: "enum", T: proto3.getEnumType(CardNetwork), repeated: true },
  ],
  {localName: "PaymentMethodSettings_CardPaymentSetting"},
);

/**
 * Encrypted payment card details.
 * NextId: 13
 *
 * @generated from message common.v1.EncryptedCard
 */
export const EncryptedCard = proto3.makeMessageType(
  "common.v1.EncryptedCard",
  () => [
    { no: 1, name: "card_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "encrypted_card_holder_name", kind: "message", T: EncryptedCardHolderName },
    { no: 2, name: "encrypted_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cvv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "encrypted_cvv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "encrypted_expiration_month", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "encrypted_expiration_year", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 8, name: "billing_address_same_as_shipping", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "encryption_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "pin_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "card_type", kind: "enum", T: proto3.getEnumType(CardType) },
    { no: 15, name: "preferred_payment_network_routing", kind: "enum", T: proto3.getEnumType(CardNetwork), opt: true },
    { no: 16, name: "preferred_routing_initiator", kind: "enum", T: proto3.getEnumType(PreferredRoutingInitiator), opt: true },
  ],
);

/**
 * Encrypted card holder name
 *
 * @generated from message common.v1.EncryptedCardHolderName
 */
export const EncryptedCardHolderName = proto3.makeMessageType(
  "common.v1.EncryptedCardHolderName",
  () => [
    { no: 1, name: "encrypted_first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "encrypted_last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "encrypted_full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Models details of a payment card or a payment token used for payments.
 *
 * @generated from message common.v1.PaymentCardOrTokenPaymentMethod
 */
export const PaymentCardOrTokenPaymentMethod = proto3.makeMessageType(
  "common.v1.PaymentCardOrTokenPaymentMethod",
  () => [
    { no: 1, name: "payment_method_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cvv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "encryption_integrity_check", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "pie_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "pie_phase_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 10, name: "original_network_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "network", kind: "enum", T: proto3.getEnumType(CardNetwork) },
    { no: 12, name: "pin_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "card_type", kind: "enum", T: proto3.getEnumType(CardType), opt: true },
  ],
);

/**
 * Other type of payment.
 * Example: voucher or checks
 *
 * @generated from message common.v1.OtherPaymentMethod
 */
export const OtherPaymentMethod = proto3.makeMessageType(
  "common.v1.OtherPaymentMethod",
  [],
);

/**
 * This is used by card present flow
 *
 * @generated from message common.v1.CardPresentPaymentMethod
 */
export const CardPresentPaymentMethod = proto3.makeMessageType(
  "common.v1.CardPresentPaymentMethod",
  () => [
    { no: 1, name: "masked_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "auth_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "card_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "card_interaction_type", kind: "enum", T: proto3.getEnumType(CardInteractionType) },
    { no: 6, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "tip_eligible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Cash type of payment.
 *
 * @generated from message common.v1.CashPaymentMethod
 */
export const CashPaymentMethod = proto3.makeMessageType(
  "common.v1.CashPaymentMethod",
  () => [
    { no: 2, name: "cash_tendered", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "change_due", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * Models details of ACH (Automated Clearing House) payment method which is used whenever someone
 * instructs the ACH network to "push" money from their account to someone else's.
 * This is mostly used in USA.
 *
 * @generated from message common.v1.AchPaymentMethod
 */
export const AchPaymentMethod = proto3.makeMessageType(
  "common.v1.AchPaymentMethod",
  () => [
    { no: 1, name: "dda_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bank_routing_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bank_account_type", kind: "enum", T: proto3.getEnumType(EcpBankAccountType) },
    { no: 5, name: "ach_verification_type", kind: "enum", T: proto3.getEnumType(AchVerificationType) },
    { no: 4, name: "billing_address", kind: "message", T: PostalAddress },
  ],
);

/**
 * Encrypted Electronic Check details.
 *
 * @generated from message common.v1.EncryptedElectronicCheck
 */
export const EncryptedElectronicCheck = proto3.makeMessageType(
  "common.v1.EncryptedElectronicCheck",
  () => [
    { no: 1, name: "encrypted_bank_routing_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "encrypted_dda_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bank_account_type", kind: "enum", T: proto3.getEnumType(EcpBankAccountType) },
    { no: 4, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 5, name: "billing_address_same_as_shipping", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "encryption_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "encrypted_account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Pay by bank request to UPG details.
 *
 * @generated from message common.v1.EncryptedPayByBank
 */
export const EncryptedPayByBank = proto3.makeMessageType(
  "common.v1.EncryptedPayByBank",
  () => [
    { no: 1, name: "tokenized_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bank_account_type", kind: "enum", T: proto3.getEnumType(EcpBankAccountType) },
    { no: 3, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 4, name: "billing_address_same_as_shipping", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "encryption_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "pay_by_bank_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines the Apple Pay Payment bundle header use to decrypt and verify the payment.
 *
 * @generated from message common.v1.ApplePayPaymentHeader
 */
export const ApplePayPaymentHeader = proto3.makeMessageType(
  "common.v1.ApplePayPaymentHeader",
  () => [
    { no: 1, name: "application_data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ephemeral_public_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "public_key_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines the Apple Pay encrypted Payment.
 *
 * @generated from message common.v1.ApplePayEncryptedPaymentBundle
 */
export const ApplePayEncryptedPaymentBundle = proto3.makeMessageType(
  "common.v1.ApplePayEncryptedPaymentBundle",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "header", kind: "message", T: ApplePayPaymentHeader },
    { no: 5, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines object to provide information about validations that has been performed on
 * returned payment method.
 *
 * @generated from message common.v1.GooglePayAssuranceDetailsSpecification
 */
export const GooglePayAssuranceDetailsSpecification = proto3.makeMessageType(
  "common.v1.GooglePayAssuranceDetailsSpecification",
  () => [
    { no: 1, name: "account_verfied", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "card_holder_authenticated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Defines object to provide information about selected payment card.
 *
 * @generated from message common.v1.GooglePayCardInfo
 */
export const GooglePayCardInfo = proto3.makeMessageType(
  "common.v1.GooglePayCardInfo",
  () => [
    { no: 1, name: "card_details", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "assurance_details", kind: "message", T: GooglePayAssuranceDetailsSpecification },
    { no: 3, name: "card_network", kind: "enum", T: proto3.getEnumType(CardNetwork) },
    { no: 4, name: "address", kind: "message", T: PostalAddress },
  ],
);

/**
 * Defines the generated token data returned from Google Pay as payment method.
 *
 * @generated from message common.v1.GooglePayTokenData
 */
export const GooglePayTokenData = proto3.makeMessageType(
  "common.v1.GooglePayTokenData",
  () => [
    { no: 1, name: "digital_signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "protocol_version", kind: "enum", T: proto3.getEnumType(GooglePayProtocolVersion) },
    { no: 3, name: "signed_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines object to provide tokenization data for the payment method.
 *
 * @generated from message common.v1.GooglePayPaymentMethodTokenizationData
 */
export const GooglePayPaymentMethodTokenizationData = proto3.makeMessageType(
  "common.v1.GooglePayPaymentMethodTokenizationData",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(GooglePayTokenizationType) },
    { no: 2, name: "token", kind: "message", T: GooglePayTokenData },
  ],
);

/**
 * Defines object to provide data for payment method in Google Pay.
 *
 * @generated from message common.v1.GooglePayPaymentMethodData
 */
export const GooglePayPaymentMethodData = proto3.makeMessageType(
  "common.v1.GooglePayPaymentMethodData",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(GooglePayPaymentMethodType) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "info", kind: "message", T: GooglePayCardInfo },
    { no: 4, name: "tokenization_data", kind: "message", T: GooglePayPaymentMethodTokenizationData },
  ],
);

/**
 * Defines the Google Pay encrypted Payment Method.
 *
 * @generated from message common.v1.GooglePayEncryptedPaymentBundle
 */
export const GooglePayEncryptedPaymentBundle = proto3.makeMessageType(
  "common.v1.GooglePayEncryptedPaymentBundle",
  () => [
    { no: 1, name: "api_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "api_version_minor", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "payment_method_data", kind: "message", T: GooglePayPaymentMethodData },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "shipping_address", kind: "message", T: PostalAddress },
  ],
);

/**
 * Defines Paze encrypted bundle.
 *
 * @generated from message common.v1.PazeEncryptedPaymentBundle
 */
export const PazeEncryptedPaymentBundle = proto3.makeMessageType(
  "common.v1.PazeEncryptedPaymentBundle",
  () => [
    { no: 1, name: "encrypted_payload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last_4_of_card_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "card_network", kind: "enum", T: proto3.getEnumType(CardNetwork), opt: true },
  ],
);

/**
 * Defines the encrypted Wallet Payment Bundle.
 *
 * @generated from message common.v1.EncryptedWalletPaymentBundle
 */
export const EncryptedWalletPaymentBundle = proto3.makeMessageType(
  "common.v1.EncryptedWalletPaymentBundle",
  () => [
    { no: 1, name: "apple_pay_encrypted_payment_bundle", kind: "message", T: ApplePayEncryptedPaymentBundle, oneof: "encrypted_payment_bundle" },
    { no: 2, name: "google_pay_encrypted_payment_bundle", kind: "message", T: GooglePayEncryptedPaymentBundle, oneof: "encrypted_payment_bundle" },
    { no: 3, name: "paze_encrypted_payment_bundle", kind: "message", T: PazeEncryptedPaymentBundle, oneof: "encrypted_payment_bundle" },
  ],
);

/**
 * Encrypted Payment Wallet details.
 *
 * @generated from message common.v1.EncryptedWallet
 */
export const EncryptedWallet = proto3.makeMessageType(
  "common.v1.EncryptedWallet",
  () => [
    { no: 1, name: "encrypted_wallet_payment_bundle", kind: "message", T: EncryptedWalletPaymentBundle },
    { no: 2, name: "billing_address", kind: "message", T: PostalAddress },
  ],
);

/**
 * Pay with payment profile referenced by ShopperProfile.payment_gateway_profile_id.
 * NextId: 7
 *
 * @generated from message common.v1.EncryptedStoredPaymentMethod
 */
export const EncryptedStoredPaymentMethod = proto3.makeMessageType(
  "common.v1.EncryptedStoredPaymentMethod",
  () => [
    { no: 2, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "card_cvv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "encrypted_card_cvv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "update_details", kind: "message", T: StoredPaymentMethodUpdateDetails },
    { no: 6, name: "encryption_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines SEPA payment method details.
 * NextId: 6
 *
 * @generated from message common.v1.EncryptedSepa
 */
export const EncryptedSepa = proto3.makeMessageType(
  "common.v1.EncryptedSepa",
  () => [
    { no: 1, name: "encrypted_bic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "encrypted_iban", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 4, name: "billing_address_same_as_shipping", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "encryption_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "shopper_email_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines stored payment method update details.
 * NextId: 6
 *
 * @generated from message common.v1.StoredPaymentMethodUpdateDetails
 */
export const StoredPaymentMethodUpdateDetails = proto3.makeMessageType(
  "common.v1.StoredPaymentMethodUpdateDetails",
  () => [
    { no: 1, name: "set_as_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "billing_address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 3, name: "card", kind: "message", T: CardUpdateDetails, oneof: "payment_method_details" },
    { no: 4, name: "ecp", kind: "message", T: EcpUpdateDetails, oneof: "payment_method_details" },
    { no: 6, name: "sepa", kind: "message", T: SepaUpdateDetails, oneof: "payment_method_details" },
  ],
);

/**
 * Defines EU LPMs.
 *
 * @generated from message common.v1.Lpm
 */
export const Lpm = proto3.makeMessageType(
  "common.v1.Lpm",
  () => [
    { no: 1, name: "lpm_type", kind: "enum", T: proto3.getEnumType(LpmType) },
    { no: 2, name: "billing_address", kind: "message", T: PostalAddress },
    { no: 3, name: "preferred_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines Klarna.
 *
 * @generated from message common.v1.Klarna
 */
export const Klarna = proto3.makeMessageType(
  "common.v1.Klarna",
  [],
);

/**
 * Defines card payment method update details.
 *
 * @generated from message common.v1.CardUpdateDetails
 */
export const CardUpdateDetails = proto3.makeMessageType(
  "common.v1.CardUpdateDetails",
  () => [
    { no: 1, name: "expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "card_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "encrypted_expiration_month", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "encrypted_expiration_year", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "encrypted_card_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * Defines ECP payment method update details.
 *
 * @generated from message common.v1.EcpUpdateDetails
 */
export const EcpUpdateDetails = proto3.makeMessageType(
  "common.v1.EcpUpdateDetails",
  () => [
    { no: 1, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines ECP payment method update details.
 *
 * @generated from message common.v1.SepaUpdateDetails
 */
export const SepaUpdateDetails = proto3.makeMessageType(
  "common.v1.SepaUpdateDetails",
  () => [
    { no: 1, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.CheckoutOptions
 */
export const CheckoutOptions = proto3.makeMessageType(
  "common.v1.CheckoutOptions",
  () => [
    { no: 1, name: "auth_options", jsonName: "authorization", kind: "message", T: AuthOptions },
    { no: 2, name: "capture_options", jsonName: "capture", kind: "message", T: CaptureOptions },
    { no: 3, name: "shopper_profile_options", jsonName: "consumerProfileOptions", kind: "message", T: ShopperProfileOptions },
    { no: 4, name: "payment_method_options", kind: "message", T: PaymentMethodOptions },
    { no: 5, name: "payment_card_sca_request", jsonName: "paymentCardAuthenticationRequest", kind: "message", T: PaymentCardScaRequest },
    { no: 6, name: "fraud_check_options", kind: "message", T: FraudCheckOptions },
    { no: 7, name: "settlement_split_options", kind: "message", T: SettlementSplitOptions },
    { no: 8, name: "cookie_policy", kind: "enum", T: proto3.getEnumType(CookiePolicy) },
    { no: 9, name: "redirect_options", kind: "message", T: RedirectOptions, opt: true },
  ],
);

/**
 * @generated from message common.v1.PaymentLinkCheckoutOptions
 */
export const PaymentLinkCheckoutOptions = proto3.makeMessageType(
  "common.v1.PaymentLinkCheckoutOptions",
  () => [
    { no: 1, name: "auth_options", jsonName: "authorization", kind: "message", T: AuthOptions },
    { no: 2, name: "capture_options", jsonName: "capture", kind: "message", T: CaptureOptions },
    { no: 3, name: "shopper_profile_options", jsonName: "consumerProfileOptions", kind: "message", T: ShopperProfileOptions },
    { no: 4, name: "payment_method_options", kind: "message", T: PaymentMethodOptions },
    { no: 5, name: "payment_card_sca_request", jsonName: "paymentCardAuthenticationRequest", kind: "message", T: PaymentCardScaRequest },
  ],
);

/**
 * @generated from message common.v1.SettlementSplitOptions
 */
export const SettlementSplitOptions = proto3.makeMessageType(
  "common.v1.SettlementSplitOptions",
  () => [
    { no: 1, name: "splits", kind: "message", T: SettlementSplitOptions_Split, repeated: true },
  ],
);

/**
 * @generated from message common.v1.SettlementSplitOptions.Split
 */
export const SettlementSplitOptions_Split = proto3.makeMessageType(
  "common.v1.SettlementSplitOptions.Split",
  () => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "us_party_identifier", kind: "message", T: SettlementSplitOptions_Split_UsPartyIdentifier, oneof: "party_identifier" },
    { no: 2, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "amount_details" },
    { no: 4, name: "line_item_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "merchant_reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SettlementSplitOptions_Split"},
);

/**
 * USA Party Identifier details
 *
 * @generated from message common.v1.SettlementSplitOptions.Split.UsPartyIdentifier
 */
export const SettlementSplitOptions_Split_UsPartyIdentifier = proto3.makeMessageType(
  "common.v1.SettlementSplitOptions.Split.UsPartyIdentifier",
  () => [
    { no: 1, name: "account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "routing_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SettlementSplitOptions_Split_UsPartyIdentifier"},
);

/**
 * @generated from message common.v1.RefundSplitOptions
 */
export const RefundSplitOptions = proto3.makeMessageType(
  "common.v1.RefundSplitOptions",
  () => [
    { no: 1, name: "splits", kind: "message", T: RefundSplitOptions_Split, repeated: true },
  ],
);

/**
 * @generated from message common.v1.RefundSplitOptions.Split
 */
export const RefundSplitOptions_Split = proto3.makeMessageType(
  "common.v1.RefundSplitOptions.Split",
  () => [
    { no: 1, name: "account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "amount_details" },
  ],
  {localName: "RefundSplitOptions_Split"},
);

/**
 * @generated from message common.v1.RedirectOptions
 */
export const RedirectOptions = proto3.makeMessageType(
  "common.v1.RedirectOptions",
  () => [
    { no: 1, name: "success_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "failure_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message common.v1.PaymentMethodOptions
 */
export const PaymentMethodOptions = proto3.makeMessageType(
  "common.v1.PaymentMethodOptions",
  () => [
    { no: 1, name: "accepted_payment_method_types", kind: "enum", T: proto3.getEnumType(PaymentMethodType), repeated: true },
    { no: 2, name: "klarna_options", kind: "message", T: KlarnaOptions },
  ],
);

/**
 * @generated from message common.v1.KlarnaOptions
 */
export const KlarnaOptions = proto3.makeMessageType(
  "common.v1.KlarnaOptions",
  () => [
    { no: 1, name: "interoperability_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.FraudCheckOptions
 */
export const FraudCheckOptions = proto3.makeMessageType(
  "common.v1.FraudCheckOptions",
  () => [
    { no: 1, name: "ignore_device_data", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "consumer_create_timestamp", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message common.v1.AuthOptions
 */
export const AuthOptions = proto3.makeMessageType(
  "common.v1.AuthOptions",
  () => [
    { no: 1, name: "auth_method", jsonName: "authorizationType", kind: "enum", T: proto3.getEnumType(AuthMethod) },
    { no: 2, name: "soft_merchant_descriptor", jsonName: "softMerchant", kind: "message", T: SoftMerchantDescriptor },
    { no: 3, name: "cit_options", kind: "message", T: CITOptions },
    { no: 4, name: "cof_options", jsonName: "cardOnFile", kind: "message", T: AuthOptions_CofOptions },
    { no: 5, name: "is_estimated_amount", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "soft_merchant_descriptors", kind: "message", T: SoftMerchantDescriptors },
    { no: 7, name: "sub_merchant_supplemental_data", kind: "message", T: SubMerchantSupplementalData },
    { no: 8, name: "partial_authorization_support", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.AuthOptions.CofOptions
 */
export const AuthOptions_CofOptions = proto3.makeMessageType(
  "common.v1.AuthOptions.CofOptions",
  () => [
    { no: 1, name: "type", jsonName: "transactionType", kind: "enum", T: proto3.getEnumType(AuthOptions_CofOptions_CofTransactionType) },
    { no: 2, name: "recurring_payment_details", kind: "message", T: AuthOptions_CofOptions_RecurringPaymentDetails, oneof: "cof_details" },
    { no: 3, name: "installment_payment_details", kind: "message", T: AuthOptions_CofOptions_InstallmentPaymentDetails, oneof: "cof_details" },
  ],
  {localName: "AuthOptions_CofOptions"},
);

/**
 * Defines CoF transaction types.
 *
 * @generated from enum common.v1.AuthOptions.CofOptions.CofTransactionType
 */
export const AuthOptions_CofOptions_CofTransactionType = proto3.makeEnum(
  "common.v1.AuthOptions.CofOptions.CofTransactionType",
  [
    {no: 0, name: "COF_TRANSACTION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COF_TRANSACTION_TYPE_RECURRING", localName: "RECURRING"},
    {no: 2, name: "COF_TRANSACTION_TYPE_INSTALLMENT", localName: "INSTALLMENT"},
    {no: 3, name: "COF_TRANSACTION_TYPE_UNSCHEDULED", localName: "UNSCHEDULED"},
  ],
);

/**
 * @generated from message common.v1.AuthOptions.CofOptions.RecurringPaymentDetails
 */
export const AuthOptions_CofOptions_RecurringPaymentDetails = proto3.makeMessageType(
  "common.v1.AuthOptions.CofOptions.RecurringPaymentDetails",
  () => [
    { no: 1, name: "payment_agreement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "AuthOptions_CofOptions_RecurringPaymentDetails"},
);

/**
 * @generated from message common.v1.AuthOptions.CofOptions.InstallmentPaymentDetails
 */
export const AuthOptions_CofOptions_InstallmentPaymentDetails = proto3.makeMessageType(
  "common.v1.AuthOptions.CofOptions.InstallmentPaymentDetails",
  () => [
    { no: 1, name: "payment_plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "AuthOptions_CofOptions_InstallmentPaymentDetails"},
);

/**
 * Defines the soft descriptor.
 * Soft descriptor is a tag that will appear on the cardholder's statement and helps the cardholder
 * identify the transaction.
 * Next ID: 14
 *
 * @generated from message common.v1.SoftMerchantDescriptor
 */
export const SoftMerchantDescriptor = proto3.makeMessageType(
  "common.v1.SoftMerchantDescriptor",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_purchase_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "visa_merchant_verification_value_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "master_card_merchant_verification_value_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "merchant_incorporation_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "foreign_merchant_indicator", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "address", kind: "message", T: BusinessAddress },
    { no: 13, name: "merchant_category_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Additional data for sub merchants using Payment Facilitation.
 *
 * @generated from message common.v1.MerchantIdentification
 */
export const MerchantIdentification = proto3.makeMessageType(
  "common.v1.MerchantIdentification",
  () => [
    { no: 1, name: "sub_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "service_entitlement_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seller_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Additional data for sub merchants using Payment Facilitation.
 *
 * @generated from message common.v1.SubMerchantSupplementalData
 */
export const SubMerchantSupplementalData = proto3.makeMessageType(
  "common.v1.SubMerchantSupplementalData",
  () => [
    { no: 1, name: "merchant_identification", kind: "message", T: MerchantIdentification },
  ],
);

/**
 * Defines the soft descriptor.
 * Soft descriptor is a tag that will appear on the cardholder's statement and helps the cardholder
 * identify the transaction.
 * NextId: 7
 *
 * @generated from message common.v1.SoftMerchantDescriptors
 */
export const SoftMerchantDescriptors = proto3.makeMessageType(
  "common.v1.SoftMerchantDescriptors",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "contact_info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "address", kind: "message", T: BusinessAddress },
    { no: 5, name: "category_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "service_establishment_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "tax_exempt_charity_indicator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "seller_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines Customer initiated transaction options.
 * TODO(vmiksonov): Remove this message once we start to use CofOptions.
 *
 * @generated from message common.v1.CITOptions
 * @deprecated
 */
export const CITOptions = proto3.makeMessageType(
  "common.v1.CITOptions",
  () => [
    { no: 1, name: "cit_message_type", kind: "enum", T: proto3.getEnumType(CitMessageType) },
    { no: 2, name: "cit_store_credentials", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message common.v1.CaptureOptions
 */
export const CaptureOptions = proto3.makeMessageType(
  "common.v1.CaptureOptions",
  () => [
    { no: 1, name: "capture_method", kind: "enum", T: proto3.getEnumType(CaptureMethod) },
  ],
);

/**
 * @generated from message common.v1.ShopperProfileOptions
 */
export const ShopperProfileOptions = proto3.makeMessageType(
  "common.v1.ShopperProfileOptions",
  () => [
    { no: 1, name: "save_profile", jsonName: "isSaveConsumerProfile", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Tokenized payment method.
 *
 * @generated from message common.v1.TokenizedPaymentMethod
 */
export const TokenizedPaymentMethod = proto3.makeMessageType(
  "common.v1.TokenizedPaymentMethod",
  () => [
    { no: 1, name: "token_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(TokenType) },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(TokenizationStatus) },
    { no: 4, name: "response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "response_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * ORGANIZATION ENTITY
 *
 * @generated from message common.v1.Merchant
 */
export const Merchant = proto3.makeMessageType(
  "common.v1.Merchant",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "legal_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent_org", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_gateway_mid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "safetech_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
    { no: 13, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 14, name: "onboarding_status", kind: "enum", T: proto3.getEnumType(OnboardingStatus) },
    { no: 15, name: "auth_accounts", kind: "message", T: AuthAccount, repeated: true },
    { no: 16, name: "jpmc_wallet_program_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Shipping method information.
 *
 * @generated from message common.v1.ShippingMethod
 */
export const ShippingMethod = proto3.makeMessageType(
  "common.v1.ShippingMethod",
  () => [
    { no: 1, name: "name", kind: "message", T: LocalizedString },
    { no: 2, name: "description", kind: "message", T: LocalizedString },
    { no: 3, name: "cost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "estimated_delivery_date", kind: "message", T: Timestamp },
  ],
);

/**
 * Defines the Client used by Merchant for AuthZ/AuthN.
 *
 * @generated from message common.v1.AuthAccount
 */
export const AuthAccount = proto3.makeMessageType(
  "common.v1.AuthAccount",
  () => [
    { no: 1, name: "fid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.MandateAcknowledgement
 */
export const MandateAcknowledgement = proto3.makeMessageType(
  "common.v1.MandateAcknowledgement",
  () => [
    { no: 3, name: "mandates", kind: "message", T: MandateAcknowledgement_Mandates, repeated: true },
    { no: 4, name: "device", kind: "message", T: Device },
    { no: 5, name: "accepted_timestamp", kind: "message", T: Timestamp },
    { no: 6, name: "consents", kind: "message", T: MandateAcknowledgement_Consent, repeated: true },
  ],
);

/**
 * @generated from enum common.v1.MandateAcknowledgement.AcceptedFlag
 */
export const MandateAcknowledgement_AcceptedFlag = proto3.makeEnum(
  "common.v1.MandateAcknowledgement.AcceptedFlag",
  [
    {no: 0, name: "ACCEPTED_FLAG_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACCEPTED_FLAG_Y", localName: "Y"},
    {no: 2, name: "ACCEPTED_FLAG_N", localName: "N"},
    {no: 3, name: "ACCEPTED_FLAG_NA", localName: "NA"},
  ],
);

/**
 * Types of mandate
 *
 * @generated from enum common.v1.MandateAcknowledgement.MandateType
 */
export const MandateAcknowledgement_MandateType = proto3.makeEnum(
  "common.v1.MandateAcknowledgement.MandateType",
  [
    {no: 0, name: "MANDATE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MANDATE_TYPE_PLACE_ORDER", localName: "PLACE_ORDER"},
    {no: 2, name: "MANDATE_TYPE_CARD", localName: "CARD"},
    {no: 3, name: "MANDATE_TYPE_ECP", localName: "ECP"},
    {no: 4, name: "MANDATE_TYPE_PAY_BY_BANK", localName: "PAY_BY_BANK"},
    {no: 5, name: "MANDATE_TYPE_SEPA", localName: "SEPA"},
    {no: 6, name: "MANDATE_TYPE_GLOBAL", localName: "GLOBAL"},
  ],
);

/**
 * Types of Consents
 *
 * @generated from enum common.v1.MandateAcknowledgement.ConsentType
 */
export const MandateAcknowledgement_ConsentType = proto3.makeEnum(
  "common.v1.MandateAcknowledgement.ConsentType",
  [
    {no: 0, name: "CONSENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONSENT_TYPE_PROFILE_CONSENT", localName: "PROFILE_CONSENT"},
  ],
);

/**
 * @generated from enum common.v1.MandateAcknowledgement.AcknowledgementType
 */
export const MandateAcknowledgement_AcknowledgementType = proto3.makeEnum(
  "common.v1.MandateAcknowledgement.AcknowledgementType",
  [
    {no: 0, name: "ACKNOWLEDGEMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACKNOWLEDGEMENT_TYPE_IMPLICIT", localName: "IMPLICIT"},
    {no: 2, name: "ACKNOWLEDGEMENT_TYPE_EXPLICIT", localName: "EXPLICIT"},
  ],
);

/**
 * @generated from message common.v1.MandateAcknowledgement.Mandates
 */
export const MandateAcknowledgement_Mandates = proto3.makeMessageType(
  "common.v1.MandateAcknowledgement.Mandates",
  () => [
    { no: 1, name: "mandate_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "acknowledgement_type", kind: "enum", T: proto3.getEnumType(MandateAcknowledgement_AcknowledgementType) },
    { no: 3, name: "accepted_flag", kind: "enum", T: proto3.getEnumType(MandateAcknowledgement_AcceptedFlag) },
    { no: 4, name: "mandate_verbiage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "mandate_type", kind: "enum", T: proto3.getEnumType(MandateAcknowledgement_MandateType) },
  ],
  {localName: "MandateAcknowledgement_Mandates"},
);

/**
 * @generated from message common.v1.MandateAcknowledgement.Consent
 */
export const MandateAcknowledgement_Consent = proto3.makeMessageType(
  "common.v1.MandateAcknowledgement.Consent",
  () => [
    { no: 1, name: "acknowledgement_type", kind: "enum", T: proto3.getEnumType(MandateAcknowledgement_AcknowledgementType) },
    { no: 2, name: "accepted_flag", kind: "enum", T: proto3.getEnumType(MandateAcknowledgement_AcceptedFlag) },
    { no: 3, name: "consent_verbiage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "consent_type", kind: "enum", T: proto3.getEnumType(MandateAcknowledgement_ConsentType) },
  ],
  {localName: "MandateAcknowledgement_Consent"},
);

/**
 * @generated from message common.v1.Device
 */
export const Device = proto3.makeMessageType(
  "common.v1.Device",
  () => [
    { no: 1, name: "device_ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.ExpiresAfter
 */
export const ExpiresAfter = proto3.makeMessageType(
  "common.v1.ExpiresAfter",
  () => [
    { no: 1, name: "after", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "unit_time", kind: "enum", T: proto3.getEnumType(UnitTime) },
  ],
);

/**
 * @generated from message common.v1.ExpiryInfo
 */
export const ExpiryInfo = proto3.makeMessageType(
  "common.v1.ExpiryInfo",
  () => [
    { no: 1, name: "expires_on", kind: "message", T: Timestamp, oneof: "expiry_info" },
    { no: 2, name: "expires_after", kind: "message", T: ExpiresAfter, oneof: "expiry_info" },
  ],
);

/**
 * @generated from message common.v1.CardTypeIndicators
 */
export const CardTypeIndicators = proto3.makeMessageType(
  "common.v1.CardTypeIndicators",
  () => [
    { no: 1, name: "durbin_regulated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "level3_eligible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "issuance_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "card_type_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "card_issuer_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "card_product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "card_product_type", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message common.v1.IdaSettingsInput
 */
export const IdaSettingsInput = proto3.makeMessageType(
  "common.v1.IdaSettingsInput",
  () => [
    { no: 1, name: "operation", kind: "enum", T: proto3.getEnumType(Operation) },
    { no: 2, name: "fid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "merchant_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message common.v1.IdentityConfigData
 */
export const IdentityConfigData = proto3.makeMessageType(
  "common.v1.IdentityConfigData",
  () => [
    { no: 1, name: "config_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "config_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.GlobalMandate
 */
export const GlobalMandate = proto3.makeMessageType(
  "common.v1.GlobalMandate",
  () => [
    { no: 1, name: "mandate_details", kind: "message", T: GlobalMandateDetails },
    { no: 2, name: "global_mandate_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "global_mandate_type", kind: "enum", T: proto3.getEnumType(GlobalMandateType) },
  ],
);

/**
 * @generated from message common.v1.GlobalMandateDetails
 */
export const GlobalMandateDetails = proto3.makeMessageType(
  "common.v1.GlobalMandateDetails",
  () => [
    { no: 1, name: "show_acknowledgement", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "acknowledgement_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "verbiage", kind: "message", T: GlobalMandateVerbiage, repeated: true },
  ],
);

/**
 * @generated from message common.v1.GlobalMandateVerbiage
 */
export const GlobalMandateVerbiage = proto3.makeMessageType(
  "common.v1.GlobalMandateVerbiage",
  () => [
    { no: 1, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.Channel
 */
export const Channel = proto3.makeMessageType(
  "common.v1.Channel",
  () => [
    { no: 1, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "store_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "channel_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "channel_type", kind: "enum", T: proto3.getEnumType(Channel_OrderChannelType) },
    { no: 7, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "source_system_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "source_system_transaction_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Order Channel Type indicates the type of channel used while placing an order
 *
 * @generated from enum common.v1.Channel.OrderChannelType
 */
export const Channel_OrderChannelType = proto3.makeEnum(
  "common.v1.Channel.OrderChannelType",
  [
    {no: 0, name: "ORDER_CHANNEL_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_CHANNEL_TYPE_WEB", localName: "WEB"},
    {no: 2, name: "ORDER_CHANNEL_TYPE_IOS", localName: "IOS"},
    {no: 3, name: "ORDER_CHANNEL_TYPE_ANDROID", localName: "ANDROID"},
  ],
);

/**
 * @generated from message common.v1.BrowserData
 */
export const BrowserData = proto3.makeMessageType(
  "common.v1.BrowserData",
  () => [
    { no: 1, name: "device_ip_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "browser_user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "device_local_time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.RefundPaymentMethodType
 */
export const RefundPaymentMethodType = proto3.makeMessageType(
  "common.v1.RefundPaymentMethodType",
  () => [
    { no: 1, name: "original_payment_method", kind: "message", T: OriginalPaymentMethod, oneof: "type" },
    { no: 2, name: "transaction_reference", kind: "message", T: TransactionReference, oneof: "type" },
    { no: 3, name: "card_present", kind: "message", T: CardPresentRefundRecord, oneof: "type" },
  ],
);

/**
 * @generated from message common.v1.OriginalPaymentMethod
 */
export const OriginalPaymentMethod = proto3.makeMessageType(
  "common.v1.OriginalPaymentMethod",
  [],
);

/**
 * @generated from message common.v1.TransactionReference
 */
export const TransactionReference = proto3.makeMessageType(
  "common.v1.TransactionReference",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * This is used by card present refund flow to record transaction details.
 *
 * @generated from message common.v1.CardPresentRefundRecord
 */
export const CardPresentRefundRecord = proto3.makeMessageType(
  "common.v1.CardPresentRefundRecord",
  () => [
    { no: 1, name: "masked_account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "auth_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "card_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "card_interaction_type", kind: "enum", T: proto3.getEnumType(CardInteractionType) },
    { no: 5, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.MerchantInfo
 */
export const MerchantInfo = proto3.makeMessageType(
  "common.v1.MerchantInfo",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
  ],
);

/**
 * Defines Wallet Program to be used in Checkout Marketplace.
 *
 * @generated from message common.v1.WalletProgram
 */
export const WalletProgram = proto3.makeMessageType(
  "common.v1.WalletProgram",
  () => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "program_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sponsored", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "ach_origin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ach_origin_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "dda", kind: "message", T: Dda },
    { no: 7, name: "jpm_company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "c1_pay_into_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "platform_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines the attributes for Demand Deposit Account.
 *
 * @generated from message common.v1.Dda
 */
export const Dda = proto3.makeMessageType(
  "common.v1.Dda",
  () => [
    { no: 1, name: "jpm_company_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "address", kind: "message", T: PostalAddress },
    { no: 6, name: "financial_institution", kind: "message", T: FinancialInstitution },
  ],
);

/**
 * Defines the attributes for Financial Institution.
 *
 * @generated from message common.v1.FinancialInstitution
 */
export const FinancialInstitution = proto3.makeMessageType(
  "common.v1.FinancialInstitution",
  () => [
    { no: 1, name: "bic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "routing_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "address", kind: "message", T: PostalAddress },
  ],
);

/**
 * @generated from message common.v1.EncryptedCardInfo
 */
export const EncryptedCardInfo = proto3.makeMessageType(
  "common.v1.EncryptedCardInfo",
  () => [
    { no: 1, name: "card", kind: "message", T: EncryptedCard },
    { no: 2, name: "is_nonce_generation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message common.v1.SendTo
 */
export const SendTo = proto3.makeMessageType(
  "common.v1.SendTo",
  () => [
    { no: 1, name: "emails", jsonName: "consumerEmails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message common.v1.MerchantOnboardingEvent
 */
export const MerchantOnboardingEvent = proto3.makeMessageType(
  "common.v1.MerchantOnboardingEvent",
  () => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_source", kind: "enum", T: proto3.getEnumType(MerchantEventSource) },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(DlqStatus) },
    { no: 4, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
    { no: 7, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "number_of_retries", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "payload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.PartialAuthInfo
 */
export const PartialAuthInfo = proto3.makeMessageType(
  "common.v1.PartialAuthInfo",
  () => [
    { no: 1, name: "partial_authorization", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "requested_authorization_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_authorized_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "remaining_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "total_processed_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "partial_authorization_support", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

